// Providers da Aplicação
import React from 'react';
// `AuthProvider` saiu: o site é anônimo. Não há login, token nem usuário —
// o conteúdo é público e a edição acontece no CRM.
import { TutorialProvider } from './contexts/TutorialContext';
import { TutorialModalProvider } from './contexts/TutorialModalContext';
import { TrainingModalProvider } from './contexts/TrainingModalContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ErrorBoundary } from 'react-error-boundary';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
      refetchIntervalInBackground: false,
    },
  },
});

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

function ErrorFallback({ error, resetErrorBoundary }: ErrorFallbackProps) {
  return (
    <div role="alert" style={{ padding: '2rem', textAlign: 'center' }}>
      <h2>Algo deu errado</h2>
      <pre style={{ color: 'red', margin: '1rem 0' }}>{error.message}</pre>
      <button type="button" onClick={resetErrorBoundary}>
        Tentar novamente
      </button>
    </div>
  );
}

interface AppProvidersProps {
  children: React.ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <TutorialProvider>
            <TutorialModalProvider>
              <TrainingModalProvider>
                  {children}
              </TrainingModalProvider>
            </TutorialModalProvider>
          </TutorialProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default AppProviders;
